<template>
  <div class="project-list">
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row type="flex">
        <el-col >
          <span>项目名称：</span>
          <el-input size="small" v-model="queryInfo.form.name" clearable @clear="getProjectList">
          </el-input>
        </el-col>
          <el-col>
          <span>项目编码：</span>
          <el-input size="small" v-model="queryInfo.form.code" clearable @clear="getProjectList">
          </el-input> 
        </el-col> 
        <el-col>
          <span>市场专员：</span>
          <el-input size="small" v-model="queryInfo.form.empName" clearable @clear="getProjectList">
          </el-input>
        </el-col>
        <el-col>
          <span>合作单位：</span>
          <el-input size="small" v-model="queryInfo.form.partner" clearable @clear="getProjectList">
          </el-input>
        </el-col>
        <el-col>
          <span>培训地区：</span>
          <el-input size="small" v-model="queryInfo.form.trainAddr" clearable @clear="getProjectList">
          </el-input>
        </el-col>
       
      </el-row>
      <el-row type="flex">
         <el-col>
          <span>项目级别：</span>
          <el-select v-model="queryInfo.form.prejectLevel" size="small" clearable @clear="getProjectList">
            <el-option v-for="(value,key) in projectLevelMap" :key="key" :label="value" :value="key">
            </el-option>
          </el-select>
        </el-col>
        <el-col>
          <span>培训模式：</span>
          <el-select v-model="queryInfo.form.mode" size="small" clearable @clear="getProjectList">
            <el-option v-for="(value,key) in modeMap" :key="key" :label="value" :value="key">
            </el-option>
          </el-select>
        </el-col>
        <el-col>
          <span>培训内容：</span>
          <el-input size="small" v-model="queryInfo.form.content" clearable @clear="getProjectList">
          </el-input>
        </el-col>
        <el-col>
          <span>培训对象：</span>
          <el-input size="small" v-model="queryInfo.form.object" clearable @clear="getProjectList">
          </el-input>
        </el-col>
        <el-col>
          <span>状 态：</span>
          <el-select v-model="queryInfo.form.state" size="small" clearable @clear="getProjectList">
            <el-option v-for="(value,key) in statusMap" :key="key" :label="value" :value="key">
            </el-option>
          </el-select>
        </el-col>
       
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col>
          <span>时 间：</span>
          <el-date-picker size="small" v-model="queryInfo.form.queryDate" :value-format="'yyyy-MM-dd HH:mm:ss'" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
          </el-date-picker>
        </el-col>
        <el-col class="btns">
          <!-- <el-button  icon="el-icon-document-add" size="small" class="new"  @click="create">新建</el-button> -->
          <el-button  size="small" class="reset" @click="reset">重置</el-button>
          <el-button  v-on:click="getProjectList" size="small" class="query">查询</el-button>
        </el-col>
      </el-row>
      <!-- 项目列表区域 -->
      <el-table :data="projectlist" border stripe header-row-class-name="theader">
        <el-table-column label="序号" prop="id" width="50px" type="index" :index="indexMethod"></el-table-column>
        <el-table-column label="项目名称" prop="name" ></el-table-column>
        <el-table-column label="项目编码" prop="code" ></el-table-column>
        <el-table-column label="市场专员" prop="empName"></el-table-column>
        <el-table-column label="状态" align='center'  :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <span :class='getTagType(scope.row.state)'>{{getStatus(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="合作单位" prop="partner"></el-table-column>
        <el-table-column label="培训地区" prop="trainAddr"></el-table-column>
        <el-table-column label="项目级别" prop="prejectLevel">
          <template slot-scope="scope">
            {{projectLevelMap[scope.row.prejectLevel]}}
          </template>
        </el-table-column>
        <el-table-column label="培训模式" prop="mode">
          <template slot-scope="scope">
            {{modeMap[scope.row.mode]}}
          </template>
        </el-table-column>
        <el-table-column label="培训内容" prop="content">
          <template slot-scope="scope">
            {{contentMap[scope.row.content]}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="培训对象" ></el-table-column> -->
        <el-table-column label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime|dateFormat('YYYY/MM/DD')}}</template>
        </el-table-column>
        <!-- <el-table-column label="专家" ></el-table-column> -->
        <el-table-column label="培训规模" >  
          <template slot-scope="scope">
            {{scope.row.scale}}人
          </template></el-table-column>
        <el-table-column label="操作"  class-name='opt-box' width="180" fixed="right">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button size="mini" @click="editProject(scope.row.id)" class="detail">详情</el-button>
            <el-button size="mini" type="danger" @click="removeById(scope.row.id)" v-has="'btn_projectlist_del'" >删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page" :page-sizes="[20, 50,100,200]" :page-size="queryInfo.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 商品搜索框 -->

  </div>
</template>

<script>
import commonData from '../../common/commonData'
import * as porjectApi from '../../api/projectAPI'

import moment from 'moment'
export default {
  data() {
    return {
      // 获取用户列表的参数对象
      queryInfo: {
        form: {
          query: '',
          // queryDate: [],
          name: "",
        },
        // 当前的页数
        page: 1,
        // 当前每页显示多少条数据
        size: 20,

      },
      projectlist: [],
      total: 0,

      userInfo: {},
      pickerOptions: {},
      statusMap: {},
      projectLevelMap: {},
      modeMap: {},
      contentMap:{},
    }
  },
  async created() {
    this.queryInfo.page = Number.parseInt(this.$route.query.page || 1);
    this.queryInfo.size = Number.parseInt(this.$route.query.size || 20);
    this.queryInfo.type = this.$route.query.type || '';
    let start = this.$route.query.start || '';
    let end = this.$route.query.end || '';
    // this.queryInfo.form.queryDate = start?[start,end] : [];
    this.queryInfo.form.name = this.$route.query.name || '';
    this.pickerOptions = commonData.pickerOptions;
    this.statusMap = commonData.projectState;
    this.projectLevelMap = commonData.projectLevel
    this.modeMap = commonData.mode
    this.contentMap = commonData.content
    this.userInfo = await this.$store.getters.getUserInfo
    this.getProjectList()
  },
  methods: {
    async getProjectList() {
      let param = { ...this.queryInfo }

      porjectApi.list(param).then(res => {
        if (res.flag) {
          console.log(res);
          this.projectlist = res.data.list
          this.total = res.data.total
        }
      })
    },


    // 监听 size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.size = newSize
      this.getProjectList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage)
      this.queryInfo.page = newPage
      this.getProjectList()
    },



    getTagType(status) {
      // var json = { 0: 'info', 1: "info", 2: '', 3: 'success', 4: 'info', 5: '', 6: 'danger' }
      let json =  { 0: 'info', 1: "primary", 2: 'primary',3:'primary',4:'primary',5:'primary',6:'primary' ,11:'success',12:'success',13:'success',14:'success',
  21:'danger',22:'danger',23:'danger',24:'danger',31:'danger'}
      return json[status];
    },
    getStatus(row) {
      let status = this.statusMap[row.state]
      if (row.is_plan == 1) {
        status = this.statusMap1[row.state]
      }
      return status
    },
    reset(){
      this.queryInfo.form={}
    },
    create(){
      this.$router.push("/addproject");
    },
    editProject(id){
      this.$router.push("/projectdetail/"+id);
    },
     async removeById(id) {
      // 弹框询问项目是否删除数据
      const confirmResult = await this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
     
      let res = await porjectApi.del(id)
      if (res.flag) {
        this.getProjectList()
        this.$message.success('删除成功')
      }

    },
    indexMethod(index){
      return (this.queryInfo.page-1)*this.queryInfo.size+index+1
    }

  },
  components: {
  }
}
</script>

<style lang="less" >
.project-list {
  .el-row--flex {
    .el-col-24 {
      display: flex;
      font-size: 14px;
      color: #3c4353;
      margin-bottom: 20px;
      align-items: center;
      > span {
        white-space: nowrap;
        min-width: 70px;
        text-align: right;
      }
      .el-select{
        width: 100%;
      }
    }
      .btns{
        justify-content:flex-end;
        .new{
          background: #DDE5FF;
          border: none;
          color: #5373F5;
          width: 80px;
        }
        .query{
          border: none;
          background: #5373F5;
          color: #fff;
          width: 80px;
        }
        .reset{
          border: none;
          background: #E6E9EF;
          color: #666666;
          width: 80px;
        }

      }
    .el-col + .el-col {
      margin-left: 10px;
    }
  }

  .opt-box {
    .cell {
      padding-left: 10px;
      padding-right: 0;
     .detail{
       background: #5373F5;
       color: #fff;
       border: none;
     }
    }
  }
  .theader th{
    background: #E6E9EF !important;
    color: #3C4353;
    border-color: #E5E5E5;
  }

.el-table .cell.el-tooltip {
  white-space: normal;
  .info{
    color:#909399;
  }
  .danger{
    color:#F56C6C;
  }
  .success{
    color:#67C23A;
  }
  .primary{
    color:#409EFF;
  }
}
}
</style>
